import { Images } from '../../../../../../shared/app-constants';

export enum SeedAccountESPs {
  Gmail = 'gmail',
  Gsuite = 'gsuite',
  Outlook = 'microsoft',
  Yahoo = 'yahoo',
  Microsoft = 'o365',
  Zoho = 'zoho',
  GoDaddy = 'godaddy',
  Yandex = 'yandex',
  Sendgrid = 'sendgrid',
  Other = 'other',
}

export const ESP_PRIORITY = {
  [SeedAccountESPs.Gsuite]: 1,
  [SeedAccountESPs.Gmail]: 2,
  [SeedAccountESPs.Microsoft]: 3,
  [SeedAccountESPs.Outlook]: 4,
  [SeedAccountESPs.Zoho]: 5,
  [SeedAccountESPs.Yahoo]: 6,
  [SeedAccountESPs.GoDaddy]: 7,
  [SeedAccountESPs.Yandex]: 8,
  [SeedAccountESPs.Sendgrid]: 9,
  [SeedAccountESPs.Other]: 10,
};

export const SeedAccountLabels: Record<SeedAccountESPs, string> = {
  [SeedAccountESPs.Gmail]: 'Gmail',
  [SeedAccountESPs.Gsuite]: 'Google Workspace (US)',
  [SeedAccountESPs.Outlook]: 'Outlook',
  [SeedAccountESPs.Yahoo]: 'Yahoo',
  [SeedAccountESPs.Microsoft]: 'Microsoft Business (US)',
  [SeedAccountESPs.Zoho]: 'Zoho',
  [SeedAccountESPs.GoDaddy]: 'GoDaddy',
  [SeedAccountESPs.Yandex]: 'Yandex',
  [SeedAccountESPs.Sendgrid]: 'Sendgrid',
  [SeedAccountESPs.Other]: 'Other',
};

export const SeedAccountImages: Partial<Record<SeedAccountESPs, string>> = {
  [SeedAccountESPs.Gmail]: Images.GoogleIcon,
  [SeedAccountESPs.Gsuite]: Images.GoogleIcon,
  [SeedAccountESPs.Outlook]: Images.Outlook,
  [SeedAccountESPs.Yahoo]: Images.Yahoo,
  [SeedAccountESPs.Microsoft]: Images.Microsoft,
  [SeedAccountESPs.Zoho]: Images.Zoho,
  [SeedAccountESPs.GoDaddy]: Images.GoDaddyLogo,
};

export const customEspOrder: SeedAccountESPs[] = [
  SeedAccountESPs.Gsuite,
  SeedAccountESPs.Gmail,
  SeedAccountESPs.Microsoft,
  SeedAccountESPs.Yahoo,
  SeedAccountESPs.Zoho,
  SeedAccountESPs.Outlook,
];
